import { useCallback } from 'react'
import { useQuery, useQueryClient } from '@tanstack/react-query'

import type { AccountApi } from '@/api'

const accountQueryKeys = {
    bootstrap: (accountKey: string) => ['account', accountKey, 'bootstrap'] as const,
}

export const useAccountData = ({ accountKey, api }: { accountKey: string; api: AccountApi }) => {
    const queryClient = useQueryClient()

    const bootstrapQuery = useQuery({
        queryKey: accountQueryKeys.bootstrap(accountKey),
        queryFn: api.getBootstrap,
        retry: false,
    })

    const refreshBootstrap = useCallback(async () => {
        await queryClient.invalidateQueries({
            queryKey: accountQueryKeys.bootstrap(accountKey),
        })
    }, [queryClient, accountKey])

    const refreshAll = useCallback(async () => {
        await queryClient.invalidateQueries({
            queryKey: ['account', accountKey],
        })
    }, [queryClient, accountKey])

    return {
        bootstrap: bootstrapQuery.data ?? null,
        loading: bootstrapQuery.isPending,
        bootstrapError: bootstrapQuery.error,
        refreshBootstrap,
        refreshAll,
    }
}
